var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"circle center"},[_c('p',{staticClass:"countdown-text"},[_vm._v(_vm._s(_vm.seconds))]),_c('div',{staticClass:"l-half"}),_c('div',{staticClass:"r-half"})])])}
var staticRenderFns = []

export { render, staticRenderFns }